/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React from "react";
import styles from "./index.module.css";
import { LuDownloadCloud, LuUser2, LuBuilding } from "react-icons/lu";
import { MdOutlineDoneOutline } from "react-icons/md";

const Top = ({ step, setStep }) => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.topDiv}>
        <div className={styles.stepDiv}>
          <div
            className={step > 0 ? styles.outerCircleActive : styles.outerCircle}
          >
            <div
              className={
                step > 0 ? styles.innerCircleActive : styles.innerCircle
              }
            >
              {step > 1 ? <MdOutlineDoneOutline /> : <LuBuilding />}
            </div>
          </div>
          <div className={step > 0 ? styles.stepNameActive : styles.stepName}>
            COMPANY DETAILS
          </div>
        </div>
        <div className={styles.stepDiv}>
          <div
            className={step > 1 ? styles.outerCircleActive : styles.outerCircle}
          >
            <div
              className={
                step > 1 ? styles.innerCircleActive : styles.innerCircle
              }
            >
              {step > 2 ? <MdOutlineDoneOutline /> : <LuUser2 />}
            </div>
          </div>
          <div className={step > 1 ? styles.stepNameActive : styles.stepName}>
            CREATE USER
          </div>
        </div>

        <div className={styles.stepDiv}>
          <div
            className={step > 2 ? styles.outerCircleActive : styles.outerCircle}
          >
            <div
              className={
                step > 2 ? styles.innerCircleActive : styles.innerCircle
              }
            >
              <LuDownloadCloud />
            </div>
          </div>
          <div className={step > 2 ? styles.stepNameActive : styles.stepName}>
            DOWNLOAD
          </div>
        </div>
      </div>
      <div className={styles.topDivMob}>
        {step === 1 ? (
          <div className={styles.stepDiv}>
            <div
              className={
                step > 0 ? styles.outerCircleActive : styles.outerCircle
              }
            >
              <div
                className={
                  step > 0 ? styles.innerCircleActive : styles.innerCircle
                }
              >
                <LuBuilding />
              </div>
            </div>
            <div className={step > 0 ? styles.stepNameActive : styles.stepName}>
              COMPANY DETAILS
            </div>
          </div>
        ) : step === 2 ? (
          <div className={styles.stepDiv}>
            <div
              className={
                step > 1 ? styles.outerCircleActive : styles.outerCircle
              }
            >
              <div
                className={
                  step > 1 ? styles.innerCircleActive : styles.innerCircle
                }
              >
                <LuUser2 />
              </div>
            </div>
            <div className={step > 1 ? styles.stepNameActive : styles.stepName}>
              CREATE USER
            </div>
          </div>
        ) : (
          <div className={styles.stepDiv}>
            <div
              className={
                step > 2 ? styles.outerCircleActive : styles.outerCircle
              }
            >
              <div
                className={
                  step > 2 ? styles.innerCircleActive : styles.innerCircle
                }
              >
                <LuDownloadCloud />
              </div>
            </div>
            <div className={step > 2 ? styles.stepNameActive : styles.stepName}>
              DOWNLOAD
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Top;
